module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_sola_color_vertical-ba7e137f8ce235db1d3ffa2279257580.svg";